import { useRef, useState } from "react";
import client from "../../api/client";

const COUNTER = { title_ar: "title_en", title_en: "title_ar", body_ar: "body_en", body_en: "body_ar" };
const tr = async (text, target) =>
  text ? (await client.post("/ai/translate", { text, target, mode: "notice" })).data.text : "";

// ترجمة تلقائية للجانب الآخر بعد توقّف المستخدم عن الكتابة (0.9ث).
export const useAutoTranslate = (setF) => {
  const [translating, setTranslating] = useState("");
  const timers = useRef({});
  const autofill = (key, value) => {
    const dest = COUNTER[key];
    const to = key.endsWith("_ar") ? "en" : "ar";
    clearTimeout(timers.current[key]);
    if (!value.trim()) return;
    timers.current[key] = setTimeout(async () => {
      setTranslating(dest);
      try {
        const out = await tr(value, to);
        if (out) setF((p) => ({ ...p, [dest]: out }));
      } catch {
        /* يمكن الكتابة يدوياً */
      } finally {
        setTranslating("");
      }
    }, 900);
  };
  return { translating, autofill };
};
